import axios from "axios";
import { useAuthStore } from "@/stores/user-auth";

function baseAPI(use_token = true, content_type = null) {

	const base_url = import.meta.env.VITE_API_URL;
	const token = localStorage.getItem('user-token');
	let status = 500;
	
	let header = {
		'Accept': 'application/json',
		"Content-type": "application/json",
	}
	if (use_token) header['Authorization'] = `Bearer ${token}`;
	if (content_type) header["Content-type"] = content_type; 

	const api = axios.create({
		baseURL: base_url,
		headers: header
	});

	// before a request is made start the nprogress
	api.interceptors.request.use(config => {
		return config
	})

	// before a response is returned stop nprogress
	/*api.interceptors.response.use(response => {
		return response
	})*/
	// Успешные ответы только с кодами от 200 до 399
	api.defaults.validateStatus = status => status >= 200 && status <= 399;

	api.interceptors.response.use( response => response, error => { 
		if (error.response.status) {
			status = error.response.status;
		}
		if (status === 401) {
			localStorage.removeItem('user-token');
			const auth = useAuthStore();
			auth.userLogOut();
			window.location.href = '/';
		}

		return Promise.reject(error);
	});

	return api;
}


export default baseAPI;